"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueCustomFieldValuesAppsApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class IssueCustomFieldValuesAppsApi extends runtime.BaseAPI {
    /**
     * Updates the value of a custom field on one or more issues.  Apps can only perform this operation on [custom fields](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field/) and [custom field types](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field-type/) declared in their own manifests.  **[Permissions](#permissions) required:** Only the app that owns the custom field or custom field type can update its values with this operation.
     * Update custom field value
     */
    updateCustomFieldValueRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldIdOrKey'] == null) {
                throw new runtime.RequiredError('fieldIdOrKey', 'Required parameter "fieldIdOrKey" was null or undefined when calling updateCustomFieldValue().');
            }
            if (requestParameters['customFieldValueUpdateDetails'] == null) {
                throw new runtime.RequiredError('customFieldValueUpdateDetails', 'Required parameter "customFieldValueUpdateDetails" was null or undefined when calling updateCustomFieldValue().');
            }
            const queryParameters = {};
            if (requestParameters['generateChangelog'] != null) {
                queryParameters['generateChangelog'] = requestParameters['generateChangelog'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/app/field/{fieldIdOrKey}/value`.replace(`{${"fieldIdOrKey"}}`, encodeURIComponent(String(requestParameters['fieldIdOrKey']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CustomFieldValueUpdateDetailsToJSON)(requestParameters['customFieldValueUpdateDetails']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Updates the value of a custom field on one or more issues.  Apps can only perform this operation on [custom fields](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field/) and [custom field types](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field-type/) declared in their own manifests.  **[Permissions](#permissions) required:** Only the app that owns the custom field or custom field type can update its values with this operation.
     * Update custom field value
     */
    updateCustomFieldValue(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCustomFieldValueRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates the value of one or more custom fields on one or more issues. Combinations of custom field and issue should be unique within the request.  Apps can only perform this operation on [custom fields](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field/) and [custom field types](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field-type/) declared in their own manifests.  **[Permissions](#permissions) required:** Only the app that owns the custom field or custom field type can update its values with this operation.
     * Update custom fields
     */
    updateMultipleCustomFieldValuesRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['multipleCustomFieldValuesUpdateDetails'] == null) {
                throw new runtime.RequiredError('multipleCustomFieldValuesUpdateDetails', 'Required parameter "multipleCustomFieldValuesUpdateDetails" was null or undefined when calling updateMultipleCustomFieldValues().');
            }
            const queryParameters = {};
            if (requestParameters['generateChangelog'] != null) {
                queryParameters['generateChangelog'] = requestParameters['generateChangelog'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/app/field/value`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.MultipleCustomFieldValuesUpdateDetailsToJSON)(requestParameters['multipleCustomFieldValuesUpdateDetails']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Updates the value of one or more custom fields on one or more issues. Combinations of custom field and issue should be unique within the request.  Apps can only perform this operation on [custom fields](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field/) and [custom field types](https://developer.atlassian.com/platform/forge/manifest-reference/modules/jira-custom-field-type/) declared in their own manifests.  **[Permissions](#permissions) required:** Only the app that owns the custom field or custom field type can update its values with this operation.
     * Update custom fields
     */
    updateMultipleCustomFieldValues(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateMultipleCustomFieldValuesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.IssueCustomFieldValuesAppsApi = IssueCustomFieldValuesAppsApi;
//# sourceMappingURL=IssueCustomFieldValuesAppsApi.js.map